define('persistence/dataProviders/voicePromptDataProvider',['externalDependencies/kazooApi',
    'common/promises/promiseFactory'
], function() {

    return function() {
        var self = this;

        var KazooConstructor = require('externalDependencies/kazooApi');
        var _kazooApi = new KazooConstructor();

        var PromiseFactoryConstructor = require('common/promises/promiseFactory');
        var _promiseFactory = new PromiseFactoryConstructor();

        self.getAll = function() {
            return _promiseFactory.defer(function(deferredObject) {
                _kazooApi.callAccount('/lobby_voice_prompt', 'GET')
                    .done(function(result) {
                        deferredObject.resolve(result.data.data);
                    })
                    .fail(function(error) {
                        deferredObject.reject(error);
                    });
            });
        };

        self.getById = function(voicePromptId) {
            if (voicePromptId === null) {
                var err = new Error("Missing voicePromptId");
                throw err;
            } else {
                return _promiseFactory.defer(function(deferredObject) {

                    _kazooApi.callAccount('/lobby_voice_prompt/' + voicePromptId, 'GET')
                        .done(function(result) {
                            deferredObject.resolve(result.data.data);
                        })
                        .fail(function(error) {
                            error.voicePromptId = voicePromptId;
                            deferredObject.reject(error);
                        });
                });
            }
        };
    };
});

